import { Injectable, inject } from '@angular/core';
import { Career } from '../models/career';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { IGenericJSON } from '../helpers/interface';

@Injectable({
  providedIn: 'root',
})
export class CareerPageService {
  private http = inject(HttpClient);
  private base = '/api/careerPage';

  getCareers() {
    return this.http
      .get<IGenericJSON[]>(this.base)
      .pipe(map((data: any) => Career.digestResponse(data)));
  }

  getCareerById(id: string) {
    return this.http
      .get<IGenericJSON>(`${this.base}/${id}`)
      .pipe(map((data: any) => Career.digest(data)));
  }

  getTypes(): Observable<any[]> {
    return this.http.get<any[]>(`${this.base}/types`);
  }

  updateCounselor(id: number, data: Partial<Career>): Observable<Career> {
    return this.http.put<Career>(`${this.base}/${id}`, data);
  }

  createCareer(form: FormData): Observable<Career> {
    return this.http.post<Career>(this.base, form);
  }
  updateCareer(id: number, form: FormData): Observable<Career> {
    return this.http.put<Career>(`${this.base}/${id}`, form);
  }

  deleteCareer(career: Career): Observable<Career[]> {
    return this.http.put<Career[]>(this.base, career);
  }
}
